var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Shop")]),(_vm.product)?_c('ShopProductCard',{attrs:{"product":_vm.product}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }